module.exports = __webpack_public_path__ + "img/background_speace.dcaa7d45.svg";